export function makeColumns(includeAction) {
    const response = [
        {
            label: "Username",
            field: "name",
        },
        {
            label: "Admin",
            field: "admin",
        },
        {
            label: "Status",
            field: "status",
        },
    ];

    if (includeAction) {
        response.push({
            label: "Action",
            field: "action",
        });
    }

    return response;
}
